import {
    BetSlipOddLeg,
    OddStatus,
} from '@superbet-group/web.types';

export const SgaOddStatusDto = {
    ACTIVE: 'ACTIVE',
    BLOCKED: 'BLOCKED',
    UNAVAILABLE: 'UNAVAILABLE',
} as const;
export type SgaOddStatusDto = typeof SgaOddStatusDto[keyof typeof SgaOddStatusDto];

export function getOddStatusFromSgaOdd(status: SgaOddStatusDto): OddStatus {
    switch (status) {
        case SgaOddStatusDto.ACTIVE:
            return OddStatus.Active;
        case SgaOddStatusDto.BLOCKED:
            return OddStatus.Blocked;
        case SgaOddStatusDto.UNAVAILABLE:
            return OddStatus.Unspecified;
    }
}

export type SgaOddPriceLegDto = Omit<BetSlipOddLeg, 'status'> & {
    status: SgaOddStatusDto;
};

export type SgaOddPriceDto = {
    // Unique UUID generated from the component IDs given in the request
    sgaUuid: string;

    // Price for this SGA
    price: number;

    // String representing the status of this SGA, (i.e. is it possible to bet on it)
    status: SgaOddStatusDto;

    // String representing the outcome ID of this SGA combination.
    outcomeId: string;

    // String representing the market ID of this SGA combination.
    // It's essentially a hardcoded market ID per sport.
    marketId: string;

    legs: SgaOddPriceLegDto[];
};
